export function extractApiList<T>(payload: unknown): T[] {
  if (Array.isArray(payload)) {
    return payload as T[];
  }

  if (!payload || typeof payload !== 'object') {
    return [];
  }

  const record = payload as Record<string, unknown>;
  const preferredKeys = ['items', 'data', 'results', 'tickets', 'messages', 'refunds', 'disputes', 'payments'];

  for (const key of preferredKeys) {
    const candidate = record[key];
    if (Array.isArray(candidate)) {
      return candidate as T[];
    }
    if (candidate && typeof candidate === 'object') {
      const nested = extractApiList<T>(candidate);
      if (nested.length > 0) {
        return nested;
      }
    }
  }

  return Object.values(record).filter(
    (item) => item && typeof item === 'object' && !Array.isArray(item),
  ) as T[];
}
